export const TARGET_LANGUAGE = "de";

const optionalTranslationLanguages = [ "en", "de" ];

export const isOptionalTranslationLanguage = (language) => (
    !!language && optionalTranslationLanguages.indexOf(language) !== -1
);

export const getOppositeOptionalLanguage = (language) => {
    if (language === "de") return "en";
    if (language === "en") return "de";

    return TARGET_LANGUAGE;
};

export const getOptionalTargetLanguage = (language, viewMode) => {
    if (language === "de") return viewMode === "native" ? "de" : "en";
    if (language === "en") return viewMode === "native" ? "en" : "de";

    return TARGET_LANGUAGE;
};

export const getOptionalSourceLanguage = (language, viewMode) => {
    if (language === "de") return viewMode === "native" ? "en" : "de";
    if (language === "en") return viewMode === "native" ? "de" : "en";

    return language || TARGET_LANGUAGE;
};

export const getOptionalViewMode = (language, targetLang) => targetLang === language ? "de" : "native";

export const getOptionalTranslationDirection = ({
        language,
        viewMode,
        textLanguage
    }) => {
    if (textLanguage) {
        return {
            sourceLang : textLanguage,
            targetLang : textLanguage === language ? getOppositeOptionalLanguage(language) : language
        };
    }

    if (isOptionalTranslationLanguage(language)) {
        return {
            sourceLang : getOppositeOptionalLanguage(language),
            targetLang : language
        };
    }

    return {
        sourceLang : getOptionalSourceLanguage(language, viewMode),
        targetLang : getOptionalTargetLanguage(language, viewMode)
    };
};

export const getReverseTranslationDirection = ({ sourceLang, targetLang }) => ({
    sourceLang : targetLang,
    targetLang : sourceLang
});

export const shouldRetryOptionalTranslation = (error) => {
    if (!error) return false;
    if (error.status || error.type) return false;

    return /unchanged|generic|invalid/i.test(String(error.message || ""));
};

export const getOptionalViewModeByTextLanguage = (language, textLanguage) => (
    textLanguage && textLanguage !== language ? "native" : "de"
);
